module.exports = __webpack_public_path__ + "static/crown-residences-rera_page-0002-69ebe62ae59f56a13fa4e3b27d770e69.jpg";